"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDiscountTransportList = exports.CustomerDiscountUpdateInput = exports.CustomerDiscountCreateTransport = exports.CustomerDiscountQuery = exports.EmbeddedCustomerDiscountTransport = exports.CustomerDiscountTransport = exports.DiscountDataTransport = exports.SourgumTierName = exports.SourgumTierNameLabels = exports.SourgumTierNames = exports.CustomerDiscountType = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const pricing_zone_1 = require("./pricing-zone");
const roll_off_material_price_matrix_1 = require("./roll-off-material-price-matrix");
var CustomerDiscountType;
(function (CustomerDiscountType) {
    CustomerDiscountType["PERCENTAGE"] = "PERCENTAGE";
    CustomerDiscountType["DOLLAR"] = "DOLLAR";
    CustomerDiscountType["FIXED"] = "FIXED";
})(CustomerDiscountType || (exports.CustomerDiscountType = CustomerDiscountType = {}));
exports.SourgumTierNames = ['Essentials', 'Pro', 'Elite'];
exports.SourgumTierNameLabels = {
    Essentials: 'Essentials',
    Pro: 'Pro',
    Elite: 'Elite',
};
exports.SourgumTierName = typebox_1.Type.Union([...exports.SourgumTierNames.map((value) => typebox_1.Type.Literal(value)), typebox_1.Type.String()]);
exports.DiscountDataTransport = typebox_1.Type.Pick(roll_off_material_price_matrix_1.RollOffMaterialPriceMatrix, ['material', 'sizes', 'expirationDate']);
exports.CustomerDiscountTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    pricingZone: typebox_1.Type.Optional(pricing_zone_1.PricingZone),
    pricingZoneID: typebox_1.Type.Optional(typebox_1.Type.String()),
    discountData: typebox_1.Type.Array(exports.DiscountDataTransport),
    extraRentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Number()),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    discountType: typebox_1.Type.Enum(CustomerDiscountType),
    needsReview: typebox_1.Type.Boolean(),
    /**
     * @deprecated contractor boolean is being deprecated in favor of tiered pricing through tierName
     */
    contractor: typebox_1.Type.Boolean(),
    /**
     * Needs to be a string and not an enum so haulers can create their own tier names
     */
    tierName: typebox_1.Type.Optional(exports.SourgumTierName),
    availableOnlineCheckout: typebox_1.Type.Boolean(),
    expiration: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.EmbeddedCustomerDiscountTransport = typebox_1.Type.Omit(exports.CustomerDiscountTransport, ['pricingZone', 'pricingZoneID']);
exports.CustomerDiscountQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Number()),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    pricingZoneID: typebox_1.Type.Optional(typebox_1.Type.String()),
    discountType: typebox_1.Type.Optional(typebox_1.Type.Enum(CustomerDiscountType)),
    needsReview: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    contractor: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    includeExpired: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    tieredPricing: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.CustomerDiscountCreateTransport = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.CustomerDiscountTransport, ['id', 'haulerID', 'metadata', 'pricingZone']));
exports.CustomerDiscountUpdateInput = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CustomerDiscountTransport, [
        'id',
        'haulerID',
        'metadata',
        'pricingZone',
        'rentExtensionFee',
        'extraRentalPeriod',
    ]),
    typebox_1.Type.Object({
        rentExtensionFee: (0, common_1.Nullable)(typebox_1.Type.Number()),
        extraRentalPeriod: (0, common_1.Nullable)(typebox_1.Type.Number()),
    }),
]));
exports.CustomerDiscountTransportList = typebox_1.Type.Array(exports.CustomerDiscountTransport);
//# sourceMappingURL=customer-discount-transport.js.map